function setLanguageCookie(langCode: string) {
  document.cookie = `lang=${langCode}; expires=Sun, 1 Jan 2040 00:00:00 GMT; domain=${document.domain}; path=/`
}

export default setLanguageCookie
